const TERMINAL_WORKFLOW_STATUSES = ['SUCCEEDED', 'FAILED']
const FILES_REFRESH_WORKFLOW_TYPES = ['CONVERT', 'COMBINE_PDF', 'SUGGEST_REDACTIONS', 'APPLY_REDACTIONS', 'EDIT_REDACTIONS']

const WORKFLOW_REFRESH_ACTIONS = {
  NONE: 'NONE',
  CATEGORY: 'CATEGORY',
  CATEGORY_FILES: 'CATEGORY_FILES',
  DUPLICATES: 'DUPLICATES'
}

function getWorkflowRefreshAction(workflow, { fallbackToCategoryRefresh = false } = {}) {
  if (!workflow) return fallbackToCategoryRefresh ? WORKFLOW_REFRESH_ACTIONS.CATEGORY : WORKFLOW_REFRESH_ACTIONS.NONE

  if (workflow.status === 'SUCCEEDED') {
    if (FILES_REFRESH_WORKFLOW_TYPES.includes(workflow.type)) return WORKFLOW_REFRESH_ACTIONS.CATEGORY_FILES

    if (workflow.type === 'FIND_DUPLICATES') return WORKFLOW_REFRESH_ACTIONS.DUPLICATES

    return WORKFLOW_REFRESH_ACTIONS.CATEGORY
  }

  if (TERMINAL_WORKFLOW_STATUSES.includes(workflow.status)) return WORKFLOW_REFRESH_ACTIONS.CATEGORY

  return fallbackToCategoryRefresh ? WORKFLOW_REFRESH_ACTIONS.CATEGORY : WORKFLOW_REFRESH_ACTIONS.NONE
}

export { getWorkflowRefreshAction, WORKFLOW_REFRESH_ACTIONS }
